import colors from "../../styles/variables/colors";

interface TermColoristParams {
  currentFilterStep: number;
}

export const TermColorist = ({currentFilterStep}: TermColoristParams) => {

  const currentColor = {
    background: '',
    text: colors.slate.base,
    backgroundHover: colors.white.base,
    textHover: colors.slate.base,
  }

  switch (currentFilterStep) {
    case 1:
      currentColor.background = colors.orange.base;
      break;
    case 2:
      currentColor.background = colors.blue.base;
      currentColor.text = colors.white.base;
      break;
    case 3:
      currentColor.background = colors.white.base;
      currentColor.backgroundHover = colors.slate.base;
      currentColor.textHover = colors.white.base;
      break;
    default:
      currentColor.background = colors.yellow.base;
  }

  return currentColor;
}

export default TermColorist;
